/* TODO: t() */
import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { Button, Text, ColorPicker, Modal } from '../uiold';

import { WHITE_RGB_COLOR } from '../uiold/Constants';
import { RGBColor } from '../../types/shared/Account';
import FormBuilderActions from '../../support/FormBuilderActions';

import { showSuccess } from '../App/AppAlert';
import SignupFormModel from '../FormBuilder/SignupFormModel';

type Props = {
  onHide: () => void;
  isModalVisible: boolean;
  formDef: SignupFormModel | null | undefined;
  saveFormDef: () => void;
};

export default function SignupFormOptionsDialog(props: Props) {
  let { onHide, isModalVisible, formDef, saveFormDef } = props;

  let [backgroundColor, setBackgroundColor] = useState<RGBColor>(
    formDef?.backgroundColor ?? WHITE_RGB_COLOR,
  );
  let onBackgroundColorChange = (color: RGBColor) => {
    setBackgroundColor(color);
  };

  if (!formDef) {
    return null;
  }

  let onSave = () => {
    if (formDef) {
      FormBuilderActions.updateForm(
        formDef,
        'backgroundColor',
        backgroundColor,
      );
      saveFormDef();
      showSuccess('Signup Form settings saved.');
      onHide();
    }
  };

  return (
    <Modal isVisible={isModalVisible} onClose={onHide} scrollBehavior="outside">
      <Modal.Header title="Signup Form Embed Options" />
      <Modal.Body>
        <View style={styles.modalContent}>
          <Text style={styles.colorLabel}>Background Color</Text>
          <ColorPicker
            selectedColor={backgroundColor}
            handleChange={onBackgroundColorChange}
          />
        </View>
      </Modal.Body>
      <Modal.Footer>
        <Button title="Cancel" onPress={onHide} />
        <Button title="Save" onPress={onSave} isPrimary />
      </Modal.Footer>
    </Modal>
  );
}

let styles = StyleSheet.create({
  modalContent: {
    flexDirection: 'row',
    flex: 1,
  },
  colorLabel: {
    marginRight: 20,
  },
});
